import { render, staticRenderFns } from "./enterpriseGoodsEdit.vue?vue&type=template&id=2bf3e4bd&scoped=true&"
import script from "./enterpriseGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./enterpriseGoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseGoodsEdit.vue?vue&type=style&index=0&id=2bf3e4bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3e4bd",
  null
  
)

export default component.exports